import {
    ProSubscriptionType,
    StripeBillingPortalDetails,
    StripeCheckoutUserDetails,
} from "@lifeat/shared/stripe/StripeSubscriptionTypes";
import { UserContextType, useUserContext } from "@contexts/UserContext";
import { functions } from "@firebase-local/firebase";
import { STRIPE_FUNCTIONS } from "@firebase-local/functions/ServerlessEndpoints";
import { logError } from "../service/ConsoleLoggerService";

function useStripeSession() {
    const { userData }: UserContextType = useUserContext();

    const getCheckoutUrl = async (subscriptionType: ProSubscriptionType, skipTrial: boolean): Promise<string> => {
        try {
            const url = await generateStripeCheckoutSession({
                email: userData.email,
                subscriptionType,
                rewardfulReferralId: window.Rewardful?.referral,
                stripeCustomerId: userData?.proUserInfo?.stripeInfo?.customerId,
                skipTrial: skipTrial,
            });
            return url;
        } catch (e) {
            alert(
                "There was an unexpected error. Please try again or reach out to LifeAt support by emailing contact@lifeat.io",
            );
        }
    };

    const getBillingPortalUrl = async (): Promise<string> => {
        try {
            const url = await generateStripeBillingPortalSession(userData.proUserInfo.stripeInfo.customerId);
            return url;
        } catch (e) {
            alert("Unexpected Operation. Please contact LifeAt Support (contact@lifeat.io)");
        }
    };

    return {
        getCheckoutUrl,
        getBillingPortalUrl,
    };
}

async function generateStripeCheckoutSession(data: StripeCheckoutUserDetails): Promise<string> {
    try {
        const sessionUrl = await functions.httpsCallable(STRIPE_FUNCTIONS.CheckoutSessionProSub)(data);
        return sessionUrl.data;
    } catch (e) {
        logError(`Unable to start Stripe Checkout session. Error: ${JSON.stringify(e)}`);
        throw e;
    }
}

async function generateStripeBillingPortalSession(customerId: string): Promise<string> {
    try {
        const data: StripeBillingPortalDetails = {
            customerId: customerId,
        };
        const sessionUrl = await functions.httpsCallable(STRIPE_FUNCTIONS.OpenBillingPortal)(data);
        return sessionUrl.data;
    } catch (e) {
        logError(`Unable to start Stripe Billing Portal session. Error: ${JSON.stringify(e)}`);
        throw e;
    }
}

export default useStripeSession;
